export const version = 'v5.5.0';
export const buildDate = '2026-06-12T00:01:13.176Z';
export const commitHash = 'b1d8e83';